import { ReactNode } from 'react';

export const ChaptersNavigatorContainer = ({ children }: { children: ReactNode }) => {
    return (
        <div className="bg-comp-grad w-full h-full min-h-0 max-h-full flex flex-col" data-testid="ChaptersNavigatorContainer">
            {children}
        </div>
    );
};
